mutation RemoveUserInbox($input: UserInboxRemoveInput!) {
    userInboxRemove(input: $input) {
        user {
            id
        }
    }
}
